export const HEADER = 'Let’s get your life insurance quotes';
